<div @scaleIn #viewModal [ngStyle]="{ '--overflow': overflow }" class="modal">
  <div class="modal-header" *ngIf="header">
    <span class="modal-close z-10 ml-4" (click)="close()"><span>&times;</span></span>
    <ng-content select="[header]"></ng-content>
  </div>
  <div
    [ngStyle]="{ '--overflow': overflow, '--width': width }"
    class="modal-content"
  >
    <ng-content select="[content]"></ng-content>
  </div>
  <div *ngIf="footer" class="modal-footer">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
<div class="modal-backdrop" tabindex="-1" (click)="close()"></div>
